import { motion } from 'framer-motion';
import styled from 'styled-components';

import ArrowButton from 'components/ArrowButton/ArrowButton';
import RichText from 'components/RichText/RichText';
import { setTypography, setVh } from 'utils/styles/mixins';
import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const BusinessCardCarouselWrapper = styled.div`
  height: 100%;
  overflow: auto;
`;

export const PersonWrapper = styled(motion.div)`
  min-height: ${setVh(100)};
  width: 700px;
  max-width: 100%;

  padding: 17px;
  ${mediaTablet(`
    padding: 120px 40px 40px;
    min-height: auto;
  `)}
`;

export const PersonHeading = styled.span`
  margin-top: 52px;
  padding: 0 17px 12px 0;

  display: block;
  color: ${colors.black};

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}

  ${mediaTablet(`
    display: none;
  `)}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;

  margin: 72px 0 0;
  ${mediaTablet(`
    margin: 96px 0 0;
  `)}
`;

export const ProfilePicture = styled.img`
  width: 100%;
`;

export const Overlay = styled.img`
  position: absolute;
  top: 0;

  width: 100%;
`;

export const Heading = styled.h1`
  color: ${colors.lighterMineShaft};

  ${({ theme: { locale } }) => setTypography('heading1', locale)}
`;

export const Description = styled(RichText)`
  color: ${colors.lighterMineShaft};

  margin: 32px 0;
  ${mediaTablet(`
    margin: 40px 0;
  `)}

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;

export const Anchor = styled.a`
  color: ${colors.lighterMineShaft};
  text-decoration: underline;

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;

export const SubtitleWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  height: 1.5em;

  inset: 0;
  margin: auto;
`;

export const Subtitle = styled(motion.span)`
  color: ${colors.black};

  width: 100%;
  height: 100%;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;

export const Navigation = styled.div`
  height: max-content;
  width: 100%;

  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  position: sticky;
  bottom: 0;

  background: ${colors.white};

  ${mediaTablet(`
    width: auto;

    position: absolute;
    inset: 0;

    margin: 0 40px;
    padding: 16px 0;

    border-bottom: 1px solid ${colors.brightGray};
  `)}
`;

export const ButtonLeft = styled(ArrowButton)`
  background: transparent;
  color: ${colors.black};

  ${mediaTablet(`
    background: ${colors.concrete};
  `)}
`;

export const ButtonRight = styled(ButtonLeft)`
  transform: rotate(180deg);
`;
